// extracted by mini-css-extract-plugin
module.exports = {"area_code":"antd-pro-pages-account-settings-components-phone-view-area_code","phone_number":"antd-pro-pages-account-settings-components-phone-view-phone_number"};